module.exports = __webpack_public_path__ + "img/katarina_events_3.1f646d69.jpg";